import { Component, OnInit } from '@angular/core';
import { UtilityService } from '@granit/common-library';

@Component({
  selector: 'nyitolap',
  templateUrl: './nyitolap.component.html',
  styleUrls: ['./nyitolap.component.scss']
})
export class NyitolapComponent implements OnInit {

  onlineKarbejelentoLink: string = "";
  onlineFizetesLink: string = "";
  ugyfelPortalLink: string = "";
  partnerPortalLink: string = "";

  constructor(private utilityService: UtilityService) { }

  ngOnInit(): void {
    this.linkek();
  }

  async linkek() {

    let model = {
      key: "OnlineKarbejelentoLink"
    }
    this.onlineKarbejelentoLink = await this.utilityService.appsettingsKeyErtekLekerese(model);

    model = {
      key: "OnlineFizetesLink"
    }
    this.onlineFizetesLink = await this.utilityService.appsettingsKeyErtekLekerese(model);

    model = {
      key: "UgyfelPortalLink"
    }
    this.ugyfelPortalLink = await this.utilityService.appsettingsKeyErtekLekerese(model);

    model = {
      key: "PartnerPortalLink"
    }
    this.partnerPortalLink = await this.utilityService.appsettingsKeyErtekLekerese(model);


    this.utilityService.dialogMegnyitasa({
      info: true,
      title: 'Rendkívüli tájékoztatás!',
      message: '<div><p>Az elmúlt napok heves viharai miatt rendkívül sok kárbejelentés érkezik hozzánk. ' +
        'Szakértőink folyamatosan teljes kapacitással dolgoznak, ennek ellenére sajnos a kárrendezés a szokásosnál és a feltételekben elvártnál tovább tarthat. ' +
        'A gyorsabb ügyintézés érdekében, azt javasoljuk, hogy a kárt az <a href=\'' + this.onlineKarbejelentoLink + '\' target=\'_blank\'><b>online kárbejelentés oldalunkon</b></a> jelentse be!</p>' +
        '<p>Kérjük továbbá, hogy a kárt szenvedett ingatlanról, vagyontárgyakról több fényképet is készítsen és szakértőnk jelentkezéséig csak a feltétlenül szükséges helyreállítási munkákat végezze el, a sérült elemeket pedig őrizze meg!</p>' +
        '<p>Megértését és az együttműködését köszönjük!</p>' +
        '<p>Gránit Biztosító Zrt.</p></div>',
      confirmButtonText: 'Bezárás'
    },
      '665px');
  }
}
